import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';
import { PendingConsents } from './PendingConsents';

/** Пока сессия восстанавливается, ничего не показываем — иначе мигает вход. */
export function RequireAuth() {
  const status = useAuthStore((state) => state.status);
  const user = useAuthStore((state) => state.user);
  const location = useLocation();

  if (status === 'loading') return <div className="min-h-full bg-page" />;
  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Документы обновились — без принятия заблокировано всё, ради чего человек
  // пришёл. Показываем принятие вместо приложения, а не баннером поверх него.
  const pending = user?.pendingConsents ?? [];
  if (pending.length > 0) return <PendingConsents pending={pending} />;

  return <Outlet />;
}

/**
 * Вход и регистрация не нужны тому, кто уже вошёл.
 *
 * Сразу после регистрации статус становится authenticated, и этот редирект
 * срабатывает раньше, чем navigate() со страницы регистрации. Поэтому решение,
 * куда вести дальше, принимается здесь: неподтверждённую почту — подтверждать.
 */
export function RequireAnonymous() {
  const status = useAuthStore((state) => state.status);
  const user = useAuthStore((state) => state.user);

  if (status === 'loading') return <div className="min-h-full bg-page" />;
  if (status === 'authenticated') {
    return <Navigate to={user && !user.emailVerified ? '/verify-email' : '/'} replace />;
  }
  return <Outlet />;
}
